<template>
  <div>
    <ListagemBase
      ref="listagem"
      nomePlural="funcionarioPreContratracao"
      nomeSingular="FuncionarioPreContratracao"
      :headers="headers"
      :buscaSimplificada="false"
      :pesquisaNomeCpf="true"
      :pesquisaData="true"
      :pesquisaStatusFuncionario="true"
      :importacaoExcel="importacaoExcel"
      :printDisponivel="impressaoPadraoDisponivel"
      :alterarTenantDisponivel="podeTransferir"
    >
      <template v-slot:[`item.actions-extra`]="{ item }">
        <v-tooltip v-if="podeReativar(item)" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              small
              :aria-label="$t('Reativar_link')"
              :disabled="reativando"
              @click="reativar(item)"
              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
              color="#67748e"
            >
              mdi-restore
            </v-icon>
          </template>
          <span>{{ $t("Reativar_link") }}</span>
        </v-tooltip>
        <v-tooltip v-if="podeImprimirDocumentos(item)" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              small
              :aria-label="$t('Imprimir_documentos_admissao')"
              @click="abrirDocumentos(item)"
              class="ma-1 btn-ls me-0.90 my-1 rounded-sm"
              color="#67748e"
            >
              mdi-printer-outline
            </v-icon>
          </template>
          <span>{{ $t("Imprimir_documentos_admissao") }}</span>
        </v-tooltip>
      </template>
    </ListagemBase>

    <DialogoDocumentosPreContratacao
      v-model="dialogoDocumentos"
      :pre-contratacao="preContratacaoDocumentos"
    />
  </div>
</template>

<script>
import ListagemBase from "@/components/base/Crud/ListagemBase";
import DataService from "@/services/pessoal/FuncionarioPreContratracaoDataService";
import { configuracaoImportacaoExcel } from "@/utils/importacaoExcel";
import DialogoDocumentosPreContratacao from "./DialogoDocumentosPreContratacao.vue";

export default {
  name: "ListagemFuncionarioPreContratracao",
  components: { ListagemBase, DialogoDocumentosPreContratacao },
  data() {
    return {
      DataService,
      reativando: false,
      dialogoDocumentos: false,
      preContratacaoDocumentos: null,
      headers: [
        { text: this.$t("CPF"), value: "cpf", sortable: "false" },
        {
          text: this.$t("Nome_social"),
          value: "nomeSocial",
          sortable: "false",
        },
        { text: this.$t("Status"), value: "status", sortable: "false" },
        { text: this.$t("Chave"), value: "key", sortable: "false" },
        { text: this.$t("Data"), value: "dtInclusao", sortable: "false" },
        {
          text: this.$t("Data_aprovacao"),
          value: "dtAprovacao",
          sortable: "false",
        },
        {
          text: this.$t("Responsavel"),
          value: "responsavel.nome",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
  computed: {
    importacaoExcel() {
      return configuracaoImportacaoExcel(this, "preContratacoes", {
        nomeArquivo: "pre-contratacoes-cadastro.xlsx",
        colunas: ["linha", "nome", "cpf", "nivelSuperior"],
      });
    },
  },
  methods: {
    hasPermission(role) {
      const permissoes = this.$store?.state?.permissoes;
      return Array.isArray(permissoes) && permissoes.includes(role);
    },
    // A impressão da pré-contratação escolhe os modelos no diálogo próprio.
    impressaoPadraoDisponivel() {
      return false;
    },
    podeReativar(item) {
      return (
        ["PREENCHIDO", "RECUSADA"].includes(item?.status) &&
        this.hasPermission("ROLE_FuncionarioPreContratracao_Update")
      );
    },
    // Só a pré-contratação em andamento muda de empresa (mesma regra da API).
    podeTransferir(item) {
      return ["PENDENTE", "PREENCHIDO"].includes(item?.status);
    },
    podeImprimirDocumentos(item) {
      return (
        !!item &&
        item.status !== "APROVADA" &&
        this.hasPermission("ROLE_FuncionarioPreContratracao_Print")
      );
    },
    abrirDocumentos(item) {
      this.preContratacaoDocumentos = item;
      this.dialogoDocumentos = true;
    },
    async reativar(item) {
      if (this.reativando || !this.podeReativar(item)) return;

      this.reativando = true;
      try {
        const confirmacao = await this.$swal.fire({
          title: this.$t("Confirmar_reativacao_pre_contratacao"),
          text: this.$t("Reativacao_pre_contratacao_mantem_dados"),
          icon: "question",
          showCancelButton: true,
          confirmButtonText: this.$t("Reativar"),
          cancelButtonText: this.$t("Cancelar"),
        });
        if (!confirmacao.isConfirmed) return;

        await DataService.reativar(item);
        this.$refs.listagem.refreshList();
        this.$swal.fire(
          this.$t("Sucesso"),
          this.$t("Pre_contratacao_reativada_com_sucesso"),
          "success"
        );
      } catch (error) {
        this.$swal.fire(
          this.$t("Erro"),
          error?.response?.data?.message ||
            this.$t("Nao_foi_possivel_reativar_pre_contratacao"),
          "error"
        );
      } finally {
        this.reativando = false;
      }
    },
  },
};
</script>

<style></style>
